import {API} from '@/typings/app';
import {getLocalStorage} from '@/utils/local-storage';

export default function http(api: API) {
  return new Promise((resolve, reject) => {
    const {url, requestInit} = api;
    const {headers} = requestInit;
    const {body} = requestInit;

    const localStorageData = getLocalStorage();
    const {wxUserInfo, ticket} = localStorageData;

    if (headers instanceof Headers) {
      if (wxUserInfo) {
        const {companyKey, memberCard, openid} = wxUserInfo;

        headers.set('companyKey', companyKey);
        headers.set('memberCard', memberCard);
        headers.set('openid', openid);
      }

      if (ticket) {
        headers.set('ticket', ticket);
      }
    }

    if (requestInit.method === 'POST' && typeof body === 'string') {
      const bodyParse = JSON.parse(body);

      if (wxUserInfo) {
        const bodyAssign = Object.assign(bodyParse, {
          companyKey: wxUserInfo.companyKey,
        });
        requestInit.body = JSON.stringify(bodyAssign);
      }
    }


    const httpRes = fetch(url, requestInit);

    httpRes.then((res) => {
      if (res.ok) {
        const bodyJson = res.json();

        bodyJson.then((valueJson) => {
          const {code, msg, data} = valueJson;
          if (code === 0) {
            resolve(data);
          } else {
            reject(msg);
          }
        }).catch((reason) => {
          reject(reason);
        });
      } else {
        reject(res.statusText);
      }
    }).catch((reason) => {
      reject(reason);
    });
  });
}
